import { Grid2 } from '@mui/material';
import CustomAutocomplete from '../HomeScreen/CustomAutocomplete';
import React, { useEffect, useMemo, useState } from 'react';
import useUrlParams from '../../hooks/useUrlParams';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';

const CoreFilters = ({ filtersUpdated, targetAssetIdsUpdated }) => {
  const dispatch = useDispatch();

  const [filterDisabled, setFilterDisabled] = useState(false);
  const { portfolios } = useSelector((state) => state.portfolios);
  const { data: assets, loading: assetsLoading } = useSelector((state) => state.assets.assets);
  const {
    portfolioIds, setPortfolios, assetIds, setAssetIds, assetType, setAssetType
  } = useUrlParams();
  const [targetAssetIds, setTargetAssetIds] = useState([]);

  const assetTypes = useMemo(() => assets
    .filter((item) => targetAssetIds.length === 0 || targetAssetIds.includes(item.id))
    .reduce((accumulator, currentObject) => {
      if (!accumulator.find((obj) => obj.type === currentObject.type)) {
        accumulator.push(currentObject);
      }
      return accumulator;
    }, [])
    .map((item) => {
      return { id: item.type, name: item.type };
    }), [assets, targetAssetIds]);

  useEffect(() => {
    if (!portfolioIds) {
      return;
    }

    dispatch(actions.getAssets(portfolioIds));
  }, [portfolioIds]);

  useEffect(() => {
    if (JSON.stringify(targetAssetIds) === JSON.stringify(assets.map((item) => item.id))) {
      return;
    }

    const newTargetAssetIds = assets.map((item) => item.id);
    setTargetAssetIds(newTargetAssetIds);
  }, [assets]);

  useEffect(() => {
    if (JSON.stringify(targetAssetIds) === JSON.stringify(assetIds)) {
      return;
    }

    const newTargetAssetIds = assets
      .filter((item) => (assetIds.length === 0 || assetIds.includes(item.id)) && (assetType.length === 0 || assetType.includes(item.type)))
      .map((item) => item.id);
    setTargetAssetIds(newTargetAssetIds);
  }, [assetIds, assetType]);

  useEffect(() => {
    filtersUpdated({ portfolioIds, assetIds, assetTypes: assetType });
  }, [portfolioIds, assetIds, assetType]);

  useEffect(() => targetAssetIdsUpdated(targetAssetIds), [targetAssetIds]);

  return (
    <Grid2 container sx={{ padding: '20px 0' }} spacing={5}>
      <Grid2 item style={{ width: '30%' }}>
        <CustomAutocomplete
          items={portfolios}
          updateUrlParams={(values) => {
            setFilterDisabled(true);
            setTimeout(() => setFilterDisabled(false), 1000);
            setPortfolios(values);
          }}
          urlParams={portfolioIds}
          label="Portfolios"
          placeholder="Portfolios"
          disabled={!!assetIds.length || filterDisabled || assetsLoading}
        />
      </Grid2>
      <Grid2 item style={{ width: '30%' }}>
        <CustomAutocomplete
          items={assets}
          updateUrlParams={(values) => {
            setFilterDisabled(true);
            setTimeout(() => setFilterDisabled(false), 1000);
            setAssetIds(values);
          }}
          urlParams={assetIds}
          label="Assets"
          placeholder="Assets"
          disabled={filterDisabled}
        />
      </Grid2>
      <Grid2 item style={{ width: '30%' }}>
        <CustomAutocomplete
          updateUrlParams={(values) => {
            setFilterDisabled(true);
            setTimeout(() => setFilterDisabled(false), 1000);
            setAssetType(values);
          }}
          urlParams={assetType}
          items={assetTypes}
          label="Asset Types"
          placeholder="Asset types"
          disabled={filterDisabled}
        />
      </Grid2>
    </Grid2>
  );
};

export default CoreFilters;
